import React, { useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Tableau from '../../tableau/Tableau';
import * as actions from '../../../../services/actions';
import Bouton from '../../Bouton/Bouton';
import { checkMot } from '../../../../ressources/functionJS/checkMot';

// [field, labelKey, width, flex]
const COLUMN_CONFIG = [
  ['group_email_id', 'group_email_id', 150, 0],
  ['project_id', 'project_id', 130, 0],
  ['email_group_name', 'email_group_name', 200, 1],
];

const createColumn = (field, labelKey, width, flex) => ({
  dataField: field,
  text: checkMot(labelKey),
  sort: true,
  ...(width ? { style: { width } } : {}),
  ...(flex ? { flex } : {}),
});

const TableauGroupeEmail = ({ selectioneLigne }) => {
  const dispatch = useDispatch();

  // Redux state
  const list_emails_groups = useSelector(
    (state) => state.alarme.list_emails_groups
  );
  const filtre_projects_list_id = useSelector(
    (state) => state.authentifie.filtre_projects_list_id
  );

  // Tableau columns
  const columns = useMemo(
    () =>
      COLUMN_CONFIG.map(([field, labelKey, width, flex]) =>
        createColumn(field, labelKey, width, flex)
      ),
    []
  );

  const handleSelect = useCallback(
    (row) => {
      if (row) {
        selectioneLigne(row);
      }
    },
    [selectioneLigne]
  );

  const selectRow = useMemo(
    () => ({
      mode: 'radio',
      clickToSelect: true,
      hideSelectAll: true,
      hideSelectColumn: true,
      style: () => ({
        background: '#a6153e',
        color: 'white',
      }),
      onSelect: (row) => {
        handleSelect(row);
      },
    }),
    [handleSelect]
  );

  // Effect to fetch email groups on mount and when filter changes
  useEffect(() => {
    dispatch(actions.reqListeGroupesEmails(filtre_projects_list_id));
  }, [dispatch, filtre_projects_list_id]);

  const handleRefresh = () => {
    dispatch(actions.reqListeGroupesEmails(filtre_projects_list_id));
  };

  // Filter out invalid rows with null IDs
  const validRows = useMemo(
    () =>
      (list_emails_groups || []).filter(
        (row) => row.group_email_id !== null && row.group_email_id !== undefined
      ),
    [list_emails_groups]
  );

  return validRows.length > 0 ? (
    <Tableau
      donnees={validRows}
      colonnes={columns}
      cleLigne="group_email_id"
      selectionnerLignes={selectRow}
    />
  ) : (
    <Bouton cliquer={handleRefresh}>{checkMot('refresh')}</Bouton>
  );
};

export default TableauGroupeEmail;
